import { render, staticRenderFns } from "./base-echart.vue?vue&type=template&id=0ddfb2a2&scoped=true&"
import script from "./base-echart.vue?vue&type=script&lang=js&"
export * from "./base-echart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddfb2a2",
  null
  
)

export default component.exports